<template>
  <div v-if="hasWindow">
    <v-overlay v-model="isOpen" />
    <VBottomSheet
      v-model="isOpen"
      fixed
    >
      <component
        :is="LanguagesListComponent"
        :languages="languages"
      />
    </VBottomSheet>
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'
import type { SideMenuLanguage } from 'src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/SideMenu.types'

const props = defineProps<{
  value: boolean
  languages: SideMenuLanguage[]
}>()

const emit = defineEmits(['input'])

const hasWindow = typeof window !== 'undefined'
const LanguagesListComponent = defineAsyncComponent(
  () => import('src/layouts/core-layout/components/CoreHeader/components/mobile/SideMenu/components/LanguagesList.vue'),
)

const isOpen = computed({
  get: () => props.value,
  set: value => emit('input', value),
})
</script>
